import { render, staticRenderFns } from "./BuildingRevenueReport.vue?vue&type=template&id=2dc485c8&"
import script from "./BuildingRevenueReport.vue?vue&type=script&lang=js&"
export * from "./BuildingRevenueReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports